angular.module('zc.core')

.directive 'zcFooter', (PageLayout) ->
  restrict: 'E'
  templateUrl: '/templates/core/views/directives/footer.html'
  link: (scope, elem, attrs) ->
    scope.PageLayout = PageLayout
    scope.$watch 'PageLayout.showFooter', (newval) ->
      if newval == false
        elem.addClass('hidden')
        $("#wrapper").addClass('no-padding')
      else
        elem.removeClass('hidden')
        $("#wrapper").removeClass('no-padding')
    scope.thisYear = moment().year()




// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/core/directives/footer.directive.coffee